import { zodResolver, type PropsWithChildren } from '@shared/utils';
import { FormProvider, useForm } from 'react-hook-form';

import { BlockedRecordCheaterSchema, type BlockedRecordCheaterFormType } from './schema';

interface BlockedRecordCheaterFormProviderProps extends PropsWithChildren {
  initialValues: BlockedRecordCheaterFormType;
}

export default function BlockedRecordCheaterFormProvider(
  props: Readonly<BlockedRecordCheaterFormProviderProps>,
) {
  const { initialValues, children } = props;

  const formContext = useForm<BlockedRecordCheaterFormType>({
    resolver: zodResolver(BlockedRecordCheaterSchema),
    defaultValues: initialValues,
  });

  return <FormProvider {...formContext}>{children}</FormProvider>;
}
